<template>
  <div class="select-student-container">
    <div class="close" @click="emitClose">
      <img src="./close.png" />
    </div>
    <h1 class="title">请选择本次试听的宝宝</h1>
    <div
      class="student"
      v-for="student in studentList"
      :key="student.id"
      @click="currentSelect = student"
    >
      <div
        class="avatar"
        :style="{ backgroundImage: `url(${student.avatar})` }"
      ></div>
      <p class="name">{{ student.name }}</p>
      <div :class="currentSelect.id === student.id ? 'select' : 'unselect'"></div>
    </div>
    <div class="button" @click="emitConfirm">
      立即下单
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select-student-container {
  position: relative;
  text-align: center;
  width: 540px;

  .close {
    position: absolute;
    right: 0px;
    top: -120px;
    width: 44px;
    height: 44px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    font-weight: bold;
    font-size: 36px;
    margin-top: 52px;
    margin-bottom: 44px;
  }

  .student {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 80px;
      margin-right: 20px;
      background-position: center;
      background-size: cover;
    }

    .name {
      text-align: left;
      width: 232px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 32px;
    }
    .select,
    .unselect {
      width: 44px;
      height: 44px;
      background-size: cover;
      background-position: center;
      margin-left: 38px;
    }

    .select {
      background-image: url(./select.png);
    }

    .unselect {
      background-image: url(./unselect.png);
    }
  }

  .button {
    border-top: 1px solid #d5d9de;
    padding-top: 28px;
    padding-bottom: 28px;
    font-size: 32px;
    color: #ff6422;
    margin-top: 10px;
  }
}
</style>

<script>
export default {
  props: {
    studentList: {
      type: Array,
      default () {
        return [
          {
            id: 1000,
            name: 'Katharine',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          },
          {
            id: 1001,
            name: 'Lorem Ipsum',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          },
          {
            id: 1002,
            name: '收代理费解耦ICU播接口老人家',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          },
          {
            id: 1003,
            name: 'qesdfwer',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          },
          {
            id: 1004,
            name: 'asdfasdfwer',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          },
          {
            id: 1004,
            name: 'zxcxzcvdfg',
            avatar: 'https://uuap.vipkid.com.cn/cas/images/logoUUAP.png'
          }
        ]
      }
    }
  },
  data () {
    return {
      currentSelect: 0
    }
  },
  watch: {
    studentList: {
      handler () {
        this.currentSelect = this.studentList[0]
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitClose () {
      this.$emit('close')
    },
    emitConfirm () {
      this.$emit('confirm', this.currentSelect)
    }
  }
}
</script>
